import { getAvatarCacheBuster } from '@/features/player/utils/avatar-cache-buster';
import { getCurrentEnvUrls } from '@/libs/config';

export function buildPlayerAvatarUri(params: {
  playerId?: string | null;
  avatarUrl?: string | null;
  avatarUpdatedAt?: number | null;
}): string | undefined {
  const avatarUrl = (params.avatarUrl ?? '').trim();
  if (avatarUrl) return avatarUrl;

  const playerId = (params.playerId ?? '').trim();
  if (!playerId) return undefined;

  const base = getCurrentEnvUrls().pictureUrl?.trim();
  if (!base) return undefined;

  const v =
    (typeof params.avatarUpdatedAt === 'number' && Number.isFinite(params.avatarUpdatedAt)
      ? params.avatarUpdatedAt
      : undefined) ?? getAvatarCacheBuster(playerId);

  return `${base}${playerId}.jpg?alt=media${v ? `&v=${v}` : ''}`;
}

export function buildPlayerAvatarSource(params: {
  playerId?: string | null;
  avatarUrl?: string | null;
  avatarUpdatedAt?: number | null;
}): { uri: string } | null {
  const uri = buildPlayerAvatarUri(params);
  return uri ? { uri } : null;
}
